// src/redux/memberSlice.ts
// 社員のマスタデータ
import { createSlice} from '@reduxjs/toolkit';
import apiAxios from '../utils/apiAxios';
import { appendAlert } from "../redux/alertSlice"
import { AnyAction, Dispatch } from "redux";

export type PlantTeamMember = {
  plant_code: string,
  plant_name: string,
  teams : TeamMember[],
}

export type TeamMember = {
  proc_code: string,
  proc_name: string,
  members : Member[],
} 

export type Member = {
  member_id: string,
  name: string,
  branch_code: string,
  branch_name: string,
  proc_code: string,
  proc_name: string,
};

type MemberList= {
  original_member: Member[],
  plant_team_member: PlantTeamMember[],
};

// 工場・所属に分類してデータを保持するために変換する
function transformMemberData(originalMembers: Member[]): PlantTeamMember[] {
  const plants: { [key: string]: PlantTeamMember } = {};

  originalMembers.forEach(member => {
    // proc_codeが"-"の場合はスキップ
    if (member.proc_code === "-") return;

    if (!plants[member.branch_code]) {
      plants[member.branch_code] = {
        plant_code: member.branch_code,
        plant_name: member.branch_name,
        teams: []
      };
    }

    let team = plants[member.branch_code].teams.find(t => t.proc_code === member.proc_code);

    if (!team) {
      team = {
        proc_code: member.proc_code,
        proc_name: member.proc_name,
        members: []
      };
      plants[member.branch_code].teams.push(team);
    }

    team.members.push(member);
  });

  const plant_team_member = Object.values(plants);
  plant_team_member.forEach(plant => {
    // 所属コード順にする
    plant.teams.sort((a, b) => {
      if (a.proc_code > b.proc_code) return 1;
      if (a.proc_code < b.proc_code) return -1;
      return 0;
    });
  });

  return plant_team_member;
}

// 初期値
const initialState: MemberList = {
  original_member: [],
  plant_team_member: [],
}

export const memberSlice = createSlice({
  name: 'Member',
  initialState, 
  reducers: {
    setMember: (state, { payload }) => {
      state.original_member = payload;
      state.plant_team_member = transformMemberData(payload);
    },
  },
});

const {setMember} = memberSlice.actions;

const fetchMember = () => {
  return async (dispatch:Dispatch<AnyAction>) => {
    try {
      const response = await apiAxios.get(`/members`);
      const data = response.data;
      dispatch(setMember(data));
    } catch (error:any) {
      console.error(error);
      dispatch(appendAlert({
        severity:"error",
        message:"データの取得に失敗しました。" + error.message,
        displayTime: 5000
      },));
    }
  }
}

export { setMember, fetchMember }
export default memberSlice.reducer;